module.exports = __webpack_public_path__ + "img/sentence-doctor-doc.e6bc1dd2.png";